import React, { useState } from "react";
import SelectField from "../../molecules/SelectField/SelectField";
import { getFontSizeField } from "../../molecules/SettingsCard/helper";
import { useTranslation } from "react-i18next";

export type FontSizeType = "normal" | "large";

interface FontSizeSelectProps {
  fontSize?: string;
  onFontSizeChange?: (value: FontSizeType) => void;
}

const FontSizeSelect = (props: FontSizeSelectProps) => {
  const { fontSize, onFontSizeChange } = props;

  const { t } = useTranslation();

  const [currentFontSize, setCurrentFontSize] = useState(fontSize ?? "normal");

  const handleChangeFontSize = (value: string) => {
    if (value === "normal" || value === "large") {
      document
        .getElementsByTagName("body")[0]
        ?.setAttribute("data-font", value);

      setCurrentFontSize(value);
      onFontSizeChange?.(value);
    }
  };

  return (
    <div>
      <SelectField
        field={getFontSizeField(t)}
        value={currentFontSize}
        onChange={handleChangeFontSize}
      />
    </div>
  );
};

export default FontSizeSelect;
